/* eslint-disable no-unused-vars */
/* eslint-disable react/no-danger */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-multi-assign */
import React, { useEffect, useState } from 'react';
import { FaSpotify, FaTimesCircle } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import {
  getMyAccount,
  getMyAccounts,
  getOpportunities,
  getSyncs,
  getTheme,
  useSpotifyCount,
  useTopGigs,
  useTopSongs,
  useTopWriters,
  whoAmI,
} from '../../../api/queries';
import ButtonDashboard from '../../../components/buttonDashboard';
import ButtonHighlight from '../../../components/buttonHighlight';
import ButtonInner from '../../../components/buttonInner';
import H2 from '../../../components/h2';
import H3 from '../../../components/h3';
import H4 from '../../../components/h4';
import Spacer from '../../../components/spacer';
import AppState from '../../../store/appstate';
import WriterIcon from '../../../images/writer-icon.png';
import SongIcon from '../../../images/song-icon.png';
import GigIcon from '../../../images/gig-icon.png';
import { themeVariables } from '../../../helpers/helpers';
import TopSongs from '../../../components/TopSongs';
import TopWriters from '../../../components/TopWriters';
import TopGigs from '../../../components/TopGigs';
import ChooseAccountModal from '../../../components/ChooseAccountModal';
import LoadingSmall from '../../../components/loadingSmall';

function Dashboard() {
  const selectedAccount = AppState.useState((s) => s.selectedAccount);

  const cookies = new Cookies();

  const [newFeatureModal, setNewFeatureModal] = useState(
    !cookies.get('s-newfeature'),
  );

  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });

  const myAccounts = getMyAccounts();

  const theme = getTheme({
    cataloguecode: myAccount?.data?.cataloguecode,
  });

  const topSongs = useTopSongs({ accounts: myAccounts?.data?.artistaccounts });
  const topWriters = useTopWriters({
    accounts: myAccounts?.data?.artistaccounts,
  });
  const topGigs = useTopGigs({ accounts: myAccounts?.data?.artistaccounts });

  const pendingSpotifyCount = useSpotifyCount({
    accounts: myAccounts?.data?.artistaccounts,
  });
  const history = useHistory();
  const opportunities = getOpportunities();
  const syncs = getSyncs();
  const [addGigModal, setAddGigModal] = useState(false);
  const [addSongModal, setAddSongModal] = useState(false);
  const [addWriterModal, setAddWriterModal] = useState(false);
  const { highlightColour } = themeVariables(theme);

  const [addOpportunityModal, setAddOpportunityModal] = useState(false);
  const [addOportunityUrl, setAddOportunityUrl] = useState(null);

  const [getSongs, setGetSongs] = useState(false);
  const [getWriters, setGetWriters] = useState(false);
  const [getGigs, setGetGigs] = useState(false);
  const [getSpotify, setGetSpotify] = useState(false);
  const { t } = useTranslation('dashboard');

  useEffect(() => {
    if (selectedAccount) {
      myAccount.refetch();
    }
  }, [selectedAccount]);
  useEffect(() => {
    if (myAccounts.isSuccess) {
      // getting tops
      if (!getSpotify) {
        setTimeout(() => {
          setGetSpotify(true);
        }, 2000);
      }
      if (!getSongs) {
        setTimeout(() => {
          setGetSongs(true);
        }, 4000);
      }
      if (!getWriters) {
        setTimeout(() => {
          setGetWriters(true);
        }, 6000);
      }
      if (!getGigs) {
        setTimeout(() => {
          setGetGigs(true);
        }, 8000);
      }
    }
  }, [myAccounts.isSuccess]);

  useEffect(() => {
    if (getGigs) {
      topGigs.refetch();
    }
  }, [getGigs]);

  useEffect(() => {
    if (getSongs) {
      topSongs.refetch();
    }
  }, [getSongs]);

  useEffect(() => {
    if (getWriters) {
      topWriters.refetch();
    }
  }, [getWriters]);

  useEffect(() => {
    if (getSpotify) {
      pendingSpotifyCount.refetch();
    }
  }, [getSpotify]);

  return (
    <>
      {!!addGigModal && (
        <ChooseAccountModal
          accounts={myAccounts?.data?.artistaccounts}
          title={t('dashboard:choose-account-gigs-modal-header')}
          to="/gigs/claim"
          setAccountChoiceModal={setAddGigModal}
          nonAdminTo="/gigs/"
        />
      )}
      {!!addOpportunityModal && addOportunityUrl && (
        <ChooseAccountModal
          accounts={myAccounts?.data?.artistaccounts}
          title={t('dashboard:choose-account-modal-header')}
          to={addOportunityUrl}
          nonAdminTo="/opportunities/"
          setAccountChoiceModal={setAddOpportunityModal}
        />
      )}
      {!!addWriterModal && (
        <ChooseAccountModal
          accounts={myAccounts?.data?.artistaccounts}
          title={t('dashboard:choose-account-writer-modal-header')}
          to="/writers/create"
          nonAdminTo="/writers/"
          setAccountChoiceModal={setAddWriterModal}
        />
      )}
      {!!addSongModal && (
        <ChooseAccountModal
          accounts={myAccounts?.data?.artistaccounts}
          title={t('dashboard:choose-account-songs-modal-header')}
          to="/songs/create"
          nonAdminTo="/songs/"
          setAccountChoiceModal={setAddSongModal}
        />
      )}

      {newFeatureModal && (
        <div className="z-40 top-0 left-0 fixed w-screen h-screen flex items-center justify-center bg-black bg-opacity-50">
          <div className="rounded-lg bg-white relative max-w-2xl w-11/12 text-center">
            <button
              type="button"
              onClick={() => {
                setNewFeatureModal(false);
                cookies.set('s-newfeature', true, { path: '/' });
              }}
              className="absolute z-50 right-0 top-0 p-5 text-2xl"
            >
              <FaTimesCircle />
            </button>
            <div className="p-4 lg:p-8 overflow-auto">
              <Spacer />
              <div className="flex items-center justify-center">
                <FaSpotify className=" mr-2" />
                <H2>{t('dashboard:spotify-modal-header')}</H2>
              </div>
              <Spacer />
              <p className="text-lg">{t('dashboard:spotify-modal-text1')}</p>
              <Spacer thin />
              <p className="text-lg">{t('dashboard:spotify-modal-text1')}</p>
              <Spacer />
              <ButtonInner
                onClick={() => {
                  setNewFeatureModal(false);
                  cookies.set('s-newfeature', true, { path: '/' });
                }}
              >
                {t('dashboard:spotify-modal-button')}
              </ButtonInner>
              <Spacer />
            </div>
          </div>
        </div>
      )}
      <div style={{ backgroundColor: '#f1f5f9' }} className="flex flex-wrap">
        <div className="mx-4 lg:mx-12 xl:mx-20 2xl:mx-40 my-6">
          <div
            style={{ borderRadius: '10px 10px 50px 50px' }}
            className="flex flex-row flex-wrap lg:flex-nowrap justify-between gap-0 lg:gap-6"
          >
            <div
              style={{ borderRadius: '30px 30px 10px 10px' }}
              className="lg:w-1/3   w-full bg-white h-28 flex items-center justify-center mb-6  px-8"
            >
              <p className="w-6/12 text-center text-xs font-semibold text-another-gray">
                {t('dashboard:spotify-suggestions')}
              </p>
              <div
                style={{ backgroundColor: '#f1f5f9' }}
                className="text-center w-7/12 rounded p-4 px-0 font-semibold text-sentric-table-text flex items-center justify-center"
              >
                {pendingSpotifyCount?.isSuccess
                  && pendingSpotifyCount?.data && (
                    <span>{pendingSpotifyCount.data?.[0]?.count}</span>
                )}

                {pendingSpotifyCount?.isLoading && <LoadingSmall />}
                {!pendingSpotifyCount?.isLoading
                  && !pendingSpotifyCount?.data && <span>-</span>}
              </div>
            </div>
            <div
              style={{ borderRadius: '30px 30px 10px 10px' }}
              className="lg:w-1/3  w-full bg-white h-28 flex items-center justify-center mb-6  px-6"
            >
              <p className="w-5/12 text-center text-xs font-semibold text-another-gray">
                {t('dashboard:last-writer-added')}
              </p>
              <div
                style={{ backgroundColor: '#f1f5f9' }}
                className="text-center w-7/12 rounded p-4 px-0 font-semibold text-sentric-table-text flex items-center justify-center"
              >
                {topWriters?.isSuccess && topWriters?.data && (
                  <span>
                    {topWriters.data?.[0]?.verifieddate
                      ? format(
                        Date.parse(topWriters.data?.[0]?.verifieddate),
                        'yyyy/MM/dd',
                      )
                      : '-'}
                  </span>
                )}

                {topWriters?.isLoading && <LoadingSmall />}

                {!topWriters?.isLoading && !topWriters?.data && <span>-</span>}
              </div>
            </div>
            <div
              style={{ borderRadius: '30px 30px 10px 10px' }}
              className="lg:w-1/3  w-full bg-white h-28 flex items-center justify-center mb-6  px-6"
            >
              <p className="w-5/12 text-center text-xs font-semibold text-another-gray">
                {t('dashboard:last-song-added')}
              </p>
              <div
                style={{ backgroundColor: '#f1f5f9' }}
                className="text-center w-7/12  rounded p-4 px-0 font-semibold text-sentric-table-text flex items-center justify-center"
              >
                {topSongs?.isSuccess && topSongs?.data && (
                  <span>
                    {topSongs.data?.[0]?.createddate
                      ? format(
                        Date.parse(topSongs.data?.[0]?.createddate),
                        'yyyy/MM/dd',
                      )
                      : '-'}
                  </span>
                )}

                {topSongs?.isLoading && <LoadingSmall />}
                {!topSongs?.isLoading && !topSongs?.data && <span>-</span>}
              </div>
            </div>
          </div>

          <div
            style={{ borderRadius: '10px 10px 50px 50px' }}
            className="bg-white flex flex-row flex-wrap p-5 justify-between"
          >
            <div className="lg:w-1/3 w-full mb-2 lg-mb-0 p-4">
              <ButtonDashboard
                id="btnDashboardAddSong"
                onClick={() => setAddSongModal(true)}
              >
                <div className="flex items-center justify-center">
                  <img className="mr-3" alt="song icon" src={SongIcon} />
                  {t('dashboard:add-new-song')}
                </div>
              </ButtonDashboard>
            </div>
            <div className="lg:w-1/3 w-full mb-2 lg-mb-0 p-4">
              <ButtonDashboard
                id="btnDashboardAddWriter"
                onClick={() => setAddWriterModal(true)}
              >
                <div className="flex items-center justify-center">
                  <img className="mr-3" alt="writer icon" src={WriterIcon} />
                  {t('dashboard:add-new-writer')}
                </div>
              </ButtonDashboard>
            </div>
            <div className="lg:w-1/3 w-full mb-2 lg-mb-0 p-4">
              <ButtonDashboard
                id="btnDashboardAddClaim"
                onClick={() => setAddGigModal(true)}
              >
                <div className="flex items-center justify-center">
                  <img className="mr-3" alt="gig icon" src={GigIcon} />
                  {t('dashboard:create-new-gig-claim')}
                </div>
              </ButtonDashboard>
            </div>
          </div>

          {theme?.data?.enable_opportunities && (
            <>
              <Spacer />
              <H2>{t('dashboard:recent-opportunities-header')}</H2>
              <Spacer />
              <div className="bg-white p-4 rounded-lg">
                {syncs.isFetching && <LoadingSmall />}
                {syncs.isSuccess
                  && syncs?.data
                  && opportunities?.data
                  && [
                    ...syncs.data.slice(0, 2),
                    ...opportunities.data.slice(0, 2),
                  ].map((s, i) => (
                    <React.Fragment key={s.ID}>
                      <button
                        onClick={() => {
                          if (i > 1) {
                            setAddOportunityUrl('/opportunities');
                          } else {
                            setAddOportunityUrl('/syncs');
                          }
                          setAddOpportunityModal(true);
                        }}
                        type="button"
                        className="p-4 w-full mb-2 lg:mb-0 lg:w-1/3"
                      >
                        <img
                          src={s.image}
                          className="w-full object-cover min-h-32 md:min-h-70 max-h-48 object-center rounded-t-lg"
                          alt="opportunity"
                        />
                        <div
                          className="text-left p-4 rounded-b-lg"
                          style={{ backgroundColor: '#f1f5f9' }}
                        >
                          <h2 className="font-semibold text-sm h-8">
                            {s.post_title}
                          </h2>
                          <Spacer thin />
                          <div
                            style={{ color: '#898fa1' }}
                            className="text-xs line-clamp-3"
                            dangerouslySetInnerHTML={{
                              __html: s.post_content,
                            }}
                          />
                          <Spacer />
                          <p
                            style={{ color: highlightColour }}
                            className="underline text-xs"
                          >
                            {t('dashboard:opportunities-find-out-more')}
                          </p>
                        </div>
                      </button>
                    </React.Fragment>
                  ))}
              </div>
            </>
          )}

          <div className="w-full flex flex-wrap">
            {theme?.data?.dashboard_box_1 && (
              <div className="w-full lg:w-1/2 lg:pr-4 mt-4">
                <div
                  className="html-content db-box bg-white rounded-lg p-4 px-8 h-full"
                  dangerouslySetInnerHTML={{
                    __html: theme?.data?.dashboard_box_1,
                  }}
                />
              </div>
            )}
            {theme?.data?.dashboard_box_2 && (
              <div className="w-full mt-4 lg:w-1/2">
                <div
                  className="html-content db-box bg-white rounded-lg p-4 px-8 h-full"
                  dangerouslySetInnerHTML={{
                    __html: theme?.data?.dashboard_box_2,
                  }}
                />
              </div>
            )}
            <Spacer />
            <H2>{t('dashboard:activity-overview-header')}</H2>
            <Spacer />
            <TopSongs />
            <Spacer />
            <div className="flex gap-8 w-full lg:flex-nowrap flex-wrap">
              <TopWriters />
              <TopGigs />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Dashboard;
